export function validateCTPS(ctps?: string): boolean {
  if (!ctps) return false
  return true
  // return /^\d{7}$/.test(ctps)
}
